import {makeStyles} from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
    flex: {
        display: 'flex'
    },
    flexCol: {
        flexDirection: 'column'
    },
    hFull: {
        height: '100%'
    },
    wFull: {
        width: '100%'
    },
    p1: {
        padding: '0.25rem'
    },
    textAlignCenter: {
        textAlign: 'center'
    },
    strikeColumn: {
        backgroundColor: '#cccccc20 !important',
        fontWeight: 500
    },
    simpleBarScroller: {
        height: '100%',
        overflowY: 'auto'
    },
    emptyDataLoader: {
        height: '200px'
    },
    emptyHeader: {
        '& thead': {
            '& th': {
                textAlign: 'right'
            }
        }
    },
    gap: {
        gap: 1
    }
}))

export default useStyles